module.exports = __webpack_public_path__ + "static/media/logo.f30b4571.webp";